(() => {
  const config = JSON.parse(document.getElementById('MayLondonConfig')?.textContent || '{}');
  const hoverMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const hoverPointer = matchMedia('(hover: hover) and (pointer: fine)');
  const activeHovers = new Map();
  const stopHover = media => {
    const state = activeHovers.get(media);
    if (!state) return;
    clearTimeout(state.timer);
    state.abort.abort();
    state.layer.classList.remove('is-ready');
    state.layer.querySelectorAll(':scope > img').forEach(image => image.remove());
    activeHovers.delete(media);
  };
  const startHover = (media, cycle) => {
    if (!media || activeHovers.has(media) || !hoverPointer.matches || document.hidden) return;
    const layer = media.querySelector('.product-card__hover');
    if (!layer) return;
    const seen = new Set([media.querySelector(':scope > img')?.getAttribute('src')]);
    const photos = [...layer.querySelectorAll('[data-hover-template]')].map(template => template.content.querySelector('img')).filter(image => {
      const src = image?.getAttribute('src');
      if (!src || seen.has(src)) return false;
      seen.add(src); return true;
    });
    if (!photos.length) return;
    const mainPhoto = media.querySelector(':scope > img');
    if (mainPhoto) photos.push(mainPhoto);
    const state = { layer, abort: new AbortController(), timer: null, index: 0, failed: new Set() };
    activeHovers.set(media, state);
    const next = () => {
      if (!media.isConnected || document.hidden) { stopHover(media); return; }
      if (activeHovers.get(media) !== state) return;
      if (state.failed.size >= photos.length) { stopHover(media); return; }
      while (state.failed.has(state.index % photos.length)) state.index++;
      const index = state.index++ % photos.length;
      const image = document.importNode(photos[index], true);
      image.alt = ''; image.loading = 'eager'; image.fetchPriority = 'low';
      let finished = false;
      const settle = success => {
        if (finished || state.abort.signal.aborted) return;
        finished = true; clearTimeout(state.timer);
        image.removeEventListener('load', loaded);
        image.removeEventListener('error', failed);
        if (success) {
          layer.querySelectorAll(':scope > img').forEach(previous => previous.remove());
          layer.append(image); layer.classList.add('is-ready');
        } else state.failed.add(index);
        if (!success || (cycle && !hoverMotion.matches && photos.length - state.failed.size > 1)) state.timer = setTimeout(next, success ? 1000 : 0);
      };
      const loaded = () => settle(image.naturalWidth > 0), failed = () => settle(false);
      image.addEventListener('load', loaded, { once: true, signal: state.abort.signal });
      image.addEventListener('error', failed, { once: true, signal: state.abort.signal });
      state.timer = setTimeout(() => settle(false), 8000);
      // Detached images load without replacing the last successfully decoded photo.
      image.src = image.getAttribute('src');
      if (image.complete) settle(image.naturalWidth > 0);
    };
    next();
  };
  document.addEventListener('pointerover', event => {
    const media = event.target.closest('.product-card__media');
    if (event.pointerType !== 'touch' && !media?.contains(event.relatedTarget)) startHover(media, true);
  });
  document.addEventListener('pointerout', event => {
    const media = event.target.closest('.product-card__media');
    if (media && !media.contains(event.relatedTarget)) stopHover(media);
  });
  document.addEventListener('focusin', event => startHover(event.target.closest('.product-card__media') || event.target.closest('a')?.querySelector('.product-card__media'), false));
  document.addEventListener('focusout', event => stopHover(event.target.closest('.product-card__media') || event.target.closest('a')?.querySelector('.product-card__media')));
  const stopAllHovers = () => [...activeHovers.keys()].forEach(stopHover);
  document.addEventListener('visibilitychange', () => { if (document.hidden) stopAllHovers(); });
  document.addEventListener('shopify:section:unload', stopAllHovers);
  addEventListener('pagehide', stopAllHovers);
  hoverMotion.addEventListener('change', stopAllHovers);
  hoverPointer.addEventListener('change', stopAllHovers);
  const header = document.querySelector('[data-storefront-header]');
  const updateHeader = () => {
    if (header) document.documentElement.style.setProperty('--ml-header-bottom', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
  };
  if (header && 'ResizeObserver' in window) new ResizeObserver(updateHeader).observe(header);
  addEventListener('resize', updateHeader, { passive: true });
  updateHeader();

  const stateKey = 'mayLondonBrowse:' + location.pathname + location.search;
  addEventListener('pagehide', () => {
    try { sessionStorage.setItem(stateKey, JSON.stringify({ y: scrollY, savedAt: Date.now() })); } catch (_) {}
  });
  addEventListener('pageshow', event => {
    if (event.persisted || performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') return;
    try {
      const state = JSON.parse(sessionStorage.getItem(stateKey) || 'null');
      if (state && Date.now() - state.savedAt < 3600000) requestAnimationFrame(() => scrollTo({ top: state.y, behavior: 'instant' }));
    } catch (_) {}
  });

  const selectSeason = () => {
    const season = location.hash.slice(1);
    const valid = ['spring', 'summer', 'autumn', 'winter'].includes(season);
    if (valid) {
      const destination = document.querySelector(`[data-season-panel="${season}"]`)?.dataset.seasonDestination;
      if (destination) {
        const url = new URL(destination, location.origin);
        if (url.origin === location.origin && url.pathname !== location.pathname && /\/collections\/(spring|summer|autumn|winter)\/?$/.test(url.pathname)) { location.replace(url.href); return; }
      }
    }
    document.querySelectorAll('[data-season-panel]').forEach(panel => { panel.hidden = valid ? panel.dataset.seasonPanel !== season : true; });
    document.querySelectorAll('[data-season-link]').forEach(link => { link.setAttribute('aria-expanded', String(valid && link.dataset.seasonLink === season)); });
    if (valid) requestAnimationFrame(() => document.querySelector('[data-season-panel]:not([hidden])')?.scrollIntoView({ block: 'start', behavior: 'auto' }));
  };
  addEventListener('hashchange', selectSeason);
  document.addEventListener('shopify:section:load', selectSeason);
  selectSeason();

  const search = document.querySelector('[data-search-modal]');
  const i18n = window.MayLondonI18n;
  let recentRevision = 0;
  async function renderSearchRecent() {
    const revision = ++recentRevision;
    if (!search) return;
    const grid = search.querySelector('[data-search-recent-grid]');
    grid.replaceChildren();
    search.querySelector('[data-search-recent]').hidden = true;
    const items = await window.MayLondonCatalog.recent(4);
    if (revision !== recentRevision) return;
    for (const item of items.slice(0, 4)) {
      if (!item || typeof item.title !== 'string' || !/^[-\p{L}\p{N}\p{M}\u2122\u00ae]+$/u.test(item.handle)) continue;
      const link = document.createElement('a'); link.className = 'search-tile'; link.href = i18n.route('products/' + encodeURIComponent(item.handle));
      try {
        const src = new URL(item.image, location.origin);
        if ((src.origin !== location.origin && src.hostname !== 'cdn.shopify.com') || !['http:', 'https:'].includes(src.protocol)) continue;
        src.searchParams.set('width', '360');
        const img = document.createElement('img'); img.src = src.href; img.width = 180; img.height = 240; img.alt = ''; img.loading = 'lazy';
        const wrap = document.createElement('span'); wrap.className = 'product-photo';
        const mark = document.createElement('span'); mark.className = 'product-watermark'; mark.setAttribute('aria-hidden', 'true'); wrap.append(img, mark); link.append(wrap);
      } catch (_) { continue; }
      const title = document.createElement('span'); title.className = 'search-tile__title'; title.textContent = item.title;
      link.append(title);
      if (item.currency === config.currency) {
        const prices = document.createElement('span'); prices.className = 'search-tile__price';
        if (Number(item.compare) > Number(item.price)) { const previous = document.createElement('s'); previous.textContent = i18n.money(Number(item.compare)); prices.append(previous); }
        const price = document.createElement('strong'); price.textContent = i18n.money(Number(item.price) || 0); prices.append(price);
        prices.insertAdjacentHTML('beforeend', window.MayLondonCatalog.icons(item)); link.append(prices);
      }
      grid.append(link);
    }
    search.querySelector('[data-search-recent]').hidden = !grid.children.length;
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-search-open]') && search) { event.preventDefault(); document.querySelector('[data-mobile-menu][open]')?.close(); renderSearchRecent(); search.showModal(); search.querySelector('input[type="search"]')?.focus(); }
    if (event.target.closest('[data-search-close]')) search?.close();
    if (event.target.closest('[data-search-clear]')) { try { localStorage.removeItem('mayLondonRecentlyViewed'); } catch (_) {} renderSearchRecent(); }
  });
  search?.addEventListener('click', event => { if (event.target === search && (event.clientX < search.getBoundingClientRect().left || event.clientX > search.getBoundingClientRect().right || event.clientY < search.getBoundingClientRect().top || event.clientY > search.getBoundingClientRect().bottom)) search.close(); });
  const popup = document.querySelector('[data-newsletter-popup]');
  document.querySelectorAll('[data-track-form]').forEach(form => form.addEventListener('submit', async event => {
    event.preventDefault();
    if (form.dataset.busy === 'true') return;
    const status = form.querySelector('[data-track-status]');
    const button = form.querySelector('button');
    form.dataset.busy = 'true'; button.disabled = true; status.textContent = i18n.t('loading');
    try {
      const endpoint = new URL(form.closest('[data-order-tracking]').dataset.endpoint, location.origin);
      if (endpoint.origin !== location.origin || endpoint.username || endpoint.password || !endpoint.pathname.startsWith('/apps/') || endpoint.search || endpoint.hash) throw new Error();
      const body = Object.fromEntries(new FormData(form)); body.method = form.dataset.trackForm;
      const response = await fetch(endpoint, { method: 'POST', credentials: 'same-origin', mode: 'same-origin', redirect: 'error', referrerPolicy: 'no-referrer', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), cache: 'no-store', signal: AbortSignal.timeout(15000) });
      if (!response.ok) throw new Error();
      const data = await response.json();
      // Only verified same-store results may be followed; the backend must authenticate ownership.
      const result = new URL(data.url, location.origin);
      if (!data.url || result.origin !== location.origin || !result.pathname.startsWith('/apps/')) throw new Error();
      location.assign(result.href);
    } catch (_) { status.textContent = i18n.t('tracking_unavailable'); }
    finally { form.dataset.busy = 'false'; button.disabled = false; }
  }));
  if (popup) {
    let paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0;
    const slides = [...popup.querySelectorAll('.newsletter-popup__slide')];
    const pause = popup.querySelector('[data-slideshow-pause]');
    const pauseLabel = () => {
      pause.setAttribute('aria-pressed', String(paused)); pause.setAttribute('aria-label', i18n.t(paused ? 'play' : 'pause'));
      pause.querySelector('[data-slide-play]').hidden = !paused;
      pause.querySelector('[data-slide-pause]').hidden = paused;
    };
    matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', event => { if (event.matches) { paused = true; pauseLabel(); } });
    pauseLabel();
    const close = () => { popup.close(); try { localStorage.setItem('mayLondonNewsletterDismissed', String(Date.now())); } catch (_) {} };
    popup.querySelectorAll('[data-newsletter-close]').forEach(button => button.addEventListener('click', close));
    popup.addEventListener('cancel', () => { try { localStorage.setItem('mayLondonNewsletterDismissed', String(Date.now())); } catch (_) {} });
    pause.addEventListener('click', () => { paused = !paused; pauseLabel(); });
    setInterval(() => { if (!popup.open || paused || document.hidden || popup.matches(':hover')) return; slides[index].classList.remove('is-active'); index = (index + 1) % slides.length; slides[index].classList.add('is-active'); }, 7000);
    let dismissed = 0, joined = false;
    try { dismissed = Number(localStorage.getItem('mayLondonNewsletterDismissed')); joined = localStorage.getItem('mayLondonNewsletterJoined') === 'true'; } catch (_) {}
    if (!joined && Date.now() - dismissed > 7 * 86400000 && !location.pathname.includes('/cart') && !config.loggedIn) {
      const deadline = Date.now() + 5 * 60000;
      const show = () => { if (Date.now() > deadline || !popup.isConnected) { clearInterval(wait); return; } if (document.hidden || document.querySelector('dialog[open], .cart-drawer.is-open, .wishlist-drawer.is-open') || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName)) return; popup.showModal(); clearInterval(wait); };
      let wait;
      setTimeout(() => { wait = setInterval(show, 3000); show(); }, Number(popup.dataset.delay || 18) * 1000);
    }
  }
})();
